import HostedMobileLayout from '../../../layouts/MobileLayout';
import HostedInitScreen from '../shared/InitScreen';

export default function HostedMobileInitPage() {
  return (
    <HostedMobileLayout>
      <HostedInitScreen />
    </HostedMobileLayout>
  );
}
